<template>
    <v-row style="max-width: 600px; margin: 0 auto;" >
        
        <v-col id="base" md="12" class="pb-0 mb-0" >
                        
            <!-- Your content -->

        </v-col>
    </v-row>
</template>


<script>
export default {
}
</script>

<style scoped>

</style>